"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rdeTypes = {
    alternativeProducts: 'alt',
    criteoProducts: 'crit',
    lastSeenProducts: 'ls',
    outfit: 'out',
    complementaryProducts: 'kem',
    similarProducts: 'aa',
    prudSysAddToBasket: 'rde',
    prudsysCategoryToBrands: 'brand',
    prudsysCategoryToBrandsPapi: 'brand_papi',
    prudsysCategoryToCategories: 'cat',
    prudsysCategoryToCategoriesPapi: 'cat_papi',
    prudsysCategoryToProducts: 'rde',
    prudsysCategoryToProductsPapi: 'rde_papi',
    prudsysHomePage: 'rde',
    prudSysProducts: 'rde',
    prudSysProductsSimilar: 'rde_similar',
    prudSysSearchTerm: 'rde',
    prudsysUserToProductsPapi: 'rde_papi',
    seriesProducts: 'ser',
};
//# sourceMappingURL=types.js.map